// Définition des tâches
export const taskDefinitions = {
    task1: {
        title: "Tâche 1",
        instructions: "Vous devez écrire un message simple (courriel, note) pour demander ou donner des informations, inviter, remercier, s'excuser, féliciter, etc.",
        expectedWords: "60-120 mots",
        duration: 12,
        icon: "✉️",
    },
    task2: {
        title: "Tâche 2",
        instructions: "Vous devez décrire une expérience ou un événement, raconter un film ou un livre, donner vos impressions sur un lieu que vous avez visité, etc.",
        expectedWords: "120-150 mots",
        duration: 18,
        icon: "📝",
    },
    task3: {
        title: "Tâche 3",
        instructions: "Vous devez exposer et défendre votre point de vue sur un sujet de société, sur l'environnement, sur une question d'actualité, etc.",
        expectedWords: "120-180 mots",
        duration: 30,
        icon: "🗣️",
    }
};

/**
 * Compte les mots dans un texte en suivant les règles du TCF
 * @param {string} text - Le texte à analyser
 * @returns {number} - Le nombre de mots
 */
export function countWords(text) {
    if (!text || text.trim() === '') {
        return 0;
    }

    // Préserver les mots composés avec trait d'union
    let processedText = text.replace(/(\w)-(\w)/g, '$1*TIRET*$2');

    // Remplacer la ponctuation par des espaces, sauf pour les chiffres décimaux
    processedText = processedText.replace(/(\d)[,.](\d)/g, '$1*DECIMAL*$2');
    processedText = processedText.replace(/[^\w\s*DECIMAL*]/g, ' ');

    // Restaurer les traits d'union et les points décimaux
    processedText = processedText.replace(/\*TIRET\*/g, '-');
    processedText = processedText.replace(/\*DECIMAL\*/g, '.');

    // Diviser en mots et compter en ignorant les chaînes vides
    const words = processedText.split(/\s+/).filter(word => word.length > 0);
    return words.length;
}

/**
 * Formate les secondes en format MM:SS
 * @param {number} seconds - Nombre de secondes
 * @returns {string} - Temps formaté
 */
export function formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
}

/**
 * Détermine le statut du compteur de mots
 * @param {string} taskId - Identifiant de la tâche
 * @param {number} wordCount - Nombre de mots
 * @returns {string} - Statut ('warning', 'danger' ou chaîne vide)
 */
export function getWordCountStatus(taskId, wordCount) {
    let status = '';

    if (taskId === 'task1') {
        if (wordCount < 60) status = 'warning';
        if (wordCount > 120) status = 'danger'; 
    } else if (taskId === 'task2') {
        if (wordCount < 120) status = 'warning';
        if (wordCount > 150) status = 'danger';
    } else if (taskId === 'task3') {
        if (wordCount < 120) status = 'warning';
        if (wordCount > 180) status = 'danger';
    }

    return status;
}

/**
 * Vérifie si l'utilisateur peut terminer l'examen
 * @param {string} examType - Type d'examen
 * @param {Object} responses - Réponses de l'utilisateur
 * @returns {boolean} - Vrai si l'utilisateur peut terminer l'examen
 */
export function canCompleteExam(examType, responses) {
    if (examType !== 'complete') {
        return true;
    }

    return responses.task1.trim() !== '' &&
        responses.task2.trim() !== '' &&
        responses.task3.trim() !== '';
}